export default {
  setLoading: (state, payload) => {
    state.loading = payload;
  },
  setSearch: (state, payload) => {
    state.search = payload;
  },
  setCategory: (state, payload) => {
    state.category = payload;
  },
  setCategoryValue: (state, payload) => {
    state.categoryValue = payload;
  },
  setUsersList: (state, payload) => {
    state.usersList = payload;
  },
  setUser: (state, payload) => {
    state.user = payload;
  },
  setError: (state, payload) => {
    state.error = payload;
  },
  setProducts: (state, payload) => {
    state.products = payload;
  },
  pushProductToCart: (state, payload) => {
    state.cart.push(payload);
  },
  setVendorsList: (state, payload) => {
    state.vendorsList = payload;
  },
  incrementItemQuantityCart: (state, payload) => {
    const objIndex = state.cart.findIndex(
      obj => obj.variantId == payload.variantId
    );

    state.cart[objIndex].quantity = parseInt(payload.quantity, 10);
    localStorage.setItem("cart", JSON.stringify(state.cart));
  },
  // changeItemQuantity: (commit, payload) => {
  //   console.log(this.store.state.cart);
  //   // commit("incrementItemQuantityCart", payload.id, payload.quantity);
  //   // localStorage.setItem("cart", JSON.stringify(state.cart));
  // },
  deleteProductFromCart: (state, payload) => {
    const objIndex = state.cart.findIndex(obj => obj.variantId == payload.id);

    state.cart.splice(objIndex, 1);
  },

  clearUser: state => (state.user = null),
  clearError: state => (state.error = null),
  initCart: state => {
    if (localStorage.getItem("cart")) {
      state.cart = JSON.parse(localStorage.getItem("cart"));
    }
  }
};
